import React, { Component } from "react";
import { Paper, withStyles } from "@material-ui/core";
import DriverMessageNotification from "../Notification/DriverMessageNotification";
import styles from "./styles";
import NotificationsOutlinedIcon from "@material-ui/icons/NotificationsOutlined";

export class NotificationPanel extends Component {
  render() {
    const { classes, containerStyles, data, openDriverChatBox } = this.props;
    return (
      <div className={classes.notificationWrapper}>
        <Paper className={` ${classes.container} ${containerStyles} customScroll`}>
          {data.map((item, index) => (
            <DriverMessageNotification data={item} key={index} openDriverChatBox={openDriverChatBox}/>
          ))}
          {!data.length ? (
            <div className={classes.emptyMsgContainer}>
              <NotificationsOutlinedIcon className={classes.emptyMsgIcon} />
              <div className={classes.emptyMsgText}>No Notifications</div>
            </div>
          ) : null}
        </Paper>
      </div>
    );
  }
}

export default withStyles(styles)(NotificationPanel);
